var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//region imports

import uuid from 'uuid';
// models
import model from '../base.model';

// storage
import { save as errorsStorageSave, get as errorsStorageGet, init as errorsStorageInit, clear as errorsStorageClear } from '../../device/errors.storage';

// helpers
import { groupItemsByDate, groupItemsByTitle, compareAlerts } from '../../services/core/alerts/alerts.helper';
import { tstToDate, dateToTst, tstToMomentDate } from '../../utils/helpers';

// utils
import { clearDuplicates } from '../../services/service/error.algorithms';

// constants
import { DATE_DETAILS_FORMAT, TIME_DETAILS_FORMAT, DATEPICKER_FORMAT, ERROR_SAVING_PERIOD_DAYS, ERROR_SAVING_LAST_COUNT } from '../../constants/data.constant';

// alerts icons
const iconError = require('../../assets/images/icons/alerts/warning.png');

//endregion


class errorModel extends model {

    //region init

    constructor(props) {
        super(props);
    }

    static create() {
        return _extends({}, super.create(), {
            items: [],
            dateGroupedItems: [],
            isNetworkError: false
        });
    }

    //endregion

    //region api

    static apiGet() {
        return _asyncToGenerator(function* () {
            return errorsStorageGet();
        })();
    }

    static processServerResponse(dispatch, params, model, serverResponse) {
        const modelClient = model.mapToClient(serverResponse);
        dispatch(model.dispatchModel({ modelClient, model }));
    }

    //endregion

    //region mapper

    static isClientEmpty(clientModel) {
        return !clientModel || !clientModel.items || !clientModel.items.length;
    }

    static mapToClient(serverModel) {
        if (!serverModel || !serverModel.errors || !serverModel.errors.length) {
            return this.create();
        }

        const items = serverModel.errors.map(this.toClientItem);
        items.sort(this.compare);

        return {
            items
        };
    }

    static compare(a, b) {
        if (+a.dateRaw > +b.dateRaw) return -1;
        if (+a.dateRaw < +b.dateRaw) return 1;

        return 0;
    }

    static toClientItem(serverModelItem) {
        const item = {
            dateRaw: serverModelItem.dateRaw,
            dateGroup: tstToMomentDate(serverModelItem.dateRaw, DATEPICKER_FORMAT),
            date: tstToMomentDate(serverModelItem.dateRaw, DATE_DETAILS_FORMAT),
            time: tstToMomentDate(serverModelItem.dateRaw, TIME_DETAILS_FORMAT),
            title: serverModelItem.title,
            status: serverModelItem.status,
            message: serverModelItem.message,
            image: serverModelItem.image,
            severity: serverModelItem.severity,
            isError: serverModelItem.isError
        };

        return item;
    }

    //endregion

    //region actions

    static actionStorageInit(model) {
        return dispatch => {
            const cb = data => {
                dispatch({
                    type: model.TYPE__ON_STORAGE_INIT,
                    payload: {
                        model,
                        modelClient: {
                            items: data.errors
                        }
                    }
                });
            };
            return errorsStorageInit(cb, model.MODEL_NAME);
        };
    }

    static actionClearNetworkError(model) {
        return dispatch => {
            dispatch({
                type: model.TYPE__CLEAR_NETWORK_ERROR,
                payload: {
                    model
                }
            });
        };
    }

    static actionAdd(model, title, message, isError = true, image = iconError, dateRaw = dateToTst(new Date())) {

        // 1 convert from server to client
        const modelClient = {
            items: [{
                title,
                message,
                dateRaw,
                dateGroup: tstToMomentDate(dateRaw, DATEPICKER_FORMAT),
                date: tstToMomentDate(dateRaw, DATE_DETAILS_FORMAT),
                time: tstToMomentDate(dateRaw, TIME_DETAILS_FORMAT),
                severity: "ERROR",
                isError
            }]
        };

        // 2 save errors in storage
        errorsStorageSave(modelClient.items);
        // do not save image in localStorage
        modelClient.items[0].image = image;

        // 3 dispatch current error
        return dispatch => {
            dispatch({
                type: model.TYPE_FROM_SERVER,
                payload: {
                    model,
                    modelClient
                }
            });
        };
    }

    //endregion

    //region reducer

    static getReduceMethod(model, type) {
        const reduceMethod = super.getReduceMethod(model, type);
        if (reduceMethod) {
            return reduceMethod;
        }
        const reducers = {
            [model.TYPE__ON_STORAGE_INIT]: model.reduceGet.bind(model),
            [model.TYPE__CLEAR_NETWORK_ERROR]: model.reduceClearNetworkError.bind(model)
        };

        return reducers[type];
    }

    static reduceGet(stateModel, action) {
        const { modelClient, model } = action.payload;
        const { items: _items } = stateModel;
        const { items } = modelClient;

        if (items && items.length) {
            items.forEach(item => {
                item.index = uuid.v4();
            });
        }

        // 1 merge all errors
        let allItems = [..._items, ...items];
        allItems.sort(compareAlerts);

        // 2 delete old errors
        const currentDate = new Date();
        allItems = allItems.filter(i => {
            const date = tstToDate(i.dateRaw);
            date.setDate(date.getDate() + ERROR_SAVING_PERIOD_DAYS);
            const isOldDate = date < currentDate;
            return !isOldDate;
        });

        if (allItems && allItems.length && allItems.length > ERROR_SAVING_LAST_COUNT) {
            allItems = allItems.slice(0, ERROR_SAVING_LAST_COUNT);
        }

        allItems = clearDuplicates(allItems);

        // 3 update errors in localStorage (after clear old)
        // errorsStorageClear();
        // errorsStorageSave(allItems);

        // 4 group (by date => by title)
        let dateGroupedItems = groupItemsByDate(allItems);
        groupItemsByTitle(dateGroupedItems);

        // 5 network error
        const isNetworkError = allItems && allItems.some(i => model.isNetworkError(i.message));

        return {
            [model.MODEL_NAME]: {
                isLoading: false,
                items: allItems,
                dateGroupedItems,
                isNetworkError
            }
        };
    }

    static reduceClearNetworkError(stateModel, action) {
        const { model } = action.payload;
        let { items } = stateModel;
        items.sort(compareAlerts);

        // 1 clear network errors
        if (items && items.length) {
            items = items.filter(i => !model.isNetworkError(i.message));
            if (items.length > ERROR_SAVING_LAST_COUNT) {
                items = items.slice(0, ERROR_SAVING_LAST_COUNT);
            }
        }

        // 2 update errors in localStorage
        errorsStorageClear();
        errorsStorageSave(items);

        // 3 group (by date => by title)
        let dateGroupedItems = groupItemsByDate(items);
        groupItemsByTitle(dateGroupedItems);

        return {
            [model.MODEL_NAME]: _extends({}, stateModel, {
                items,
                dateGroupedItems,
                isNetworkError: false
            })
        };
    }

    //endregion

    //region custom errors

    static isNetworkError(errorName) {
        return !!~["Network request failed".toLowerCase(), // RN
        'Network Error'.toLowerCase() // R
        ].indexOf(errorName.toLowerCase());
    }

    //endregion
}

errorModel.MODEL_NAME = 'errorModel';
errorModel.TYPE_REQUEST = 'REQUEST_ERRORS';
errorModel.TYPE_FROM_SERVER = 'GET_ERRORS';
errorModel.TYPE_CLEAR = 'CLEAR_ERRORS';
errorModel.TYPE__ON_STORAGE_INIT = 'TYPE_ERRORS__STORAGE_INIT';
errorModel.TYPE__CLEAR_NETWORK_ERROR = 'TYPE_ERRORS__CLEAR_NETWORK_ERROR';
export { errorModel };


// WEBPACK FOOTER //
// ./~/pluton-core/lib/models/service/error.model.js